import React from "react";

const HeroBadge = () => (
  <span
    className="inline-flex w-fit self-start items-center px-3 py-1 rounded-full border border-orange-500/40 bg-orange-500/10 text-orange-200 font-semibold text-sm tracking-wide"
    data-testid="hero-badge"
  >
    <span className="animate-pulse bg-orange-400/80 rounded-full h-2 w-2 mr-2" aria-hidden="true" />
    DIGITAL EMPLOYEE · LIVE IN 72 HOURS
  </span>
);

export default HeroBadge;
